export default "__VITE_ASSET__C8iWC_JR__"